export default __webpack_public_path__ + "static/media/black-suitcase-logo.d03b91bd.svg";